/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import { ArrowRight } from "lucide-react";

export default function HomeHero() {

    return (

        <section className="py-24">

            <div className="max-w-7xl mx-auto px-6">

                <div className="max-w-4xl">

                    <div className="
                        inline-flex
                        px-4
                        py-2
                        rounded-full
                        bg-emerald-500/10
                        text-emerald-400
                        text-sm
                        mb-6
                    ">
                        Institutional Grade Financial Analytics
                    </div>

                    <h1 className="
                        text-6xl
                        font-extrabold
                        text-white
                        leading-tight
                    ">
                        Analyze Markets.
                        <br/>
                        Manage Risk.
                        <br/>
                        Invest Better.
                    </h1>

                    <p className="
                        mt-6
                        text-xl
                        text-slate-300
                        max-w-3xl
                    ">
                        Stocks, Options, Mutual Funds,
                        Portfolio Analytics and AI-powered
                        Research in one unified platform.
                    </p>

                    <div className="flex gap-4 mt-10">

                        <a
                            href="/stock"
                            className="
                                px-6
                                py-3
                                rounded-xl
                                bg-emerald-500
                                text-white
                                font-semibold
                            "
                        >
                            Explore Markets
                        </a>

                        <a
                            href="/research"
                            className="
                                px-6
                                py-3
                                rounded-xl
                                border
                                border-slate-700
                                text-white
                            "
                        >
                            Research Hub
                        </a>

                    </div>

                </div>

            </div>

        </section>
    );
}